import React from 'react';
import type {ConnectElementRenderedState} from '../../connect/ConnectElementRenderedState';

export const RenderedStateContext = React.createContext<boolean>(true);
RenderedStateContext.displayName = 'RenderedStateContext';

export type Props = {
  renderedState: ConnectElementRenderedState;
};

export const RenderedStateProvider: React.FC<Props> = ({
  children,
  renderedState,
}) => {
  const [isRendering, setIsRendering] = React.useState<boolean>(
    renderedState.isRendered,
  );

  React.useEffect(() => {
    const observer = () => {
      setIsRendering(renderedState.isRendered);
    };
    renderedState.registerObserver(observer);
    return () => {
      renderedState.unregisterObserver(observer);
    };
  }, [renderedState]);

  if (!isRendering) {
    return null;
  }
  return (
    <RenderedStateContext.Provider value={isRendering}>
      {children}
    </RenderedStateContext.Provider>
  );
};
